import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <input #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                type="checkbox">
        </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class CheckboxComponent extends HisDynamicFieldBase<boolean> implements OnInit {
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            this.formControl.setValue( matchingConfig.defaultValue, { emitEvent: false } );
        }
    }

    ngOnInit() {
        super.initFormControl( this.value );
    }

    getControlValue(): any {
        return this.formControl.value ? this.formControl.value.toString() : 'false';
    }
}
